import authApiConfig from "./authApiConfig"

const ClinicaService = {
    async getAll () {
        console.log("sede (clinica) API ....")
        return await authApiConfig.get("/sede");
    },
    async getSedeCercana(lat,lon) {
        return await authApiConfig.get(`/sede/mas-cercana?latitud=${lat}&longitud=${lon}` );
    }
}

export default ClinicaService;